// extracted by mini-css-extract-plugin
module.exports = {"no-data":"style_no-data__2-Ear"};